class ComplainCancel {
  constructor() {

    if(document.querySelector('.complain-cancel') != null && document.querySelector('.complain-cancel') != undefined) {
      this.setEvents();
    }

  }
  
  setEvents() {

    // radios ______________________________________________________________________________________________________

    var page = document.querySelector('.complain-cancel');
    var radios = page.querySelectorAll('input');
    var button = page.querySelector('.complain-cancel__send');

    function checkRadios() {
      var check = 0;

      radios.forEach(r => {
        if(r.checked) {
          check++;
        }
      });

      if(check >= 3) {
        button.disabled = false;
      }
    }

    radios.forEach(r => {
      r.addEventListener('change', function() {
        checkRadios();
      });
    });
    
    // textarea ____________________________________________________________________________________________________

    var comment = document.querySelector('.complain-cancel__comment');

    var textarea = comment.querySelector('textarea');
    var maxLength = textarea.getAttribute('maxLength');
    var counter = comment.querySelector('.counter');

    textarea.addEventListener("keyup", function() {
      var text = textarea.value.length;
      counter.textContent = (maxLength - text);
    });
  }
    
}

$(document).ready(function() {
  const complainCancel = new ComplainCancel();
});
